import { render, staticRenderFns } from "./ReviewInfoModal.vue?vue&type=template&id=c4a99fb4&"
import script from "./ReviewInfoModal.vue?vue&type=script&lang=js&"
export * from "./ReviewInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewInfoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports